// 3rd party
import { Component, Compiler, NgModule, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// components

// modules
import { MaterialModule } from 'app/shared/material/material.module';

// models
import { ReportTemplate } from 'app/reports/shared/report-template.model';

// services
import { ReportService } from 'app/reports/shared/report.service';
import { StoredFileService } from 'app/shared/services/stored-file.service';

@Component({
  selector: 'app-report-form-dialog',
  templateUrl: './report-form-dialog.html',
  styleUrls: ['./report-form-dialog.css']
})
export class ReportFormDialogComponent implements OnInit, OnDestroy {

  customerId: number = 0;
  data: any[];
  dynamicComponent: any;
  dynamicModule: any;
  isLoading: boolean = true;
  report: any;
  values: any = {};
  subscribe: Subscription;

  constructor(
    public _compiler: Compiler,
    public dialogRef: MatDialogRef<ReportFormDialogComponent>,
    public reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.subscribe = this.reportService.get(this.report.Identifier, null, null, null, null, null, '"IsWebviewReport_=1"', '"SqlCode","JsCode"').subscribe(res => {
      let data = res.json() as ReportTemplate[];
      this.report.JsCode = data[0].JsCode;
      this.report.SqlCode = data[0].SqlCode;
      this.getValues();
      this.load();
    });
  }

  ngOnDestroy() {
    if (this.subscribe) this.subscribe.unsubscribe();
  }

  build() {
    this.dynamicComponent = this.createDynamicComponent(this.report, this.values, this.data);
    this.dynamicModule = this._compiler.compileModuleSync(this.createDynamicModule(this.dynamicComponent));
  }

  getValues() {
    let matches = this.report.JsCode.match(/\[\(ngModel\)\]\=\"values\[\'+[a-z]+\'\]\"/ig);
    matches.forEach(m => {
      let v = m.substring(21, (m.length - 3));
      this.values[v] = null;
    });
    this.values.customerId = this.customerId;
    if (!this.values.selectedFormat) {
      this.values.selectedFormat = 1;
    }
  }

  load() {
    this.reportService.load(this.report.SqlCode, this.values, undefined).subscribe(data => {
      this.data = JSON.parse(data.json());
      this.isLoading = false;
      this.build();
    });
  }

  createDynamicModule(componentType: any) {
    @NgModule({
      imports: [
        CommonModule,
        HttpModule,
        FormsModule,
        MaterialModule,
        TranslateModule,
        PdfJsViewerModule,
      ],
      declarations: [
        componentType
      ],
      entryComponents: [componentType]
    })
    class RuntimeModule { }

    return RuntimeModule;
  }

  createDynamicComponent(report: any, values: any[], data: any[]) {
    @Component({
      selector: 'app-dynamic-component',
      template: report && report.JsCode ? report.JsCode +
        `<br>
				<div *ngIf="!isLoadingReport()" fxLayout="row" style="float: right">
					<button mat-button mat-dialog-close color="warn" *ngIf="!isLoadingReport()">CANCELAR</button>
					<button mat-button (click)="submit()" color="primary" *ngIf="!isLoadingReport()">OK</button>
				</div>
        <div *ngIf="isLoadingReport()" fxLayout="row" fxLayout.sm="column" style="float: right;color: rgba(0,0,0,.54)" class="loading">Processando<span>.</span><span>.</span><span>.</span></div>
        <div [style.display]="'none'">
          <ng2-pdfjs-viewer #pdfViewer [externalWindow]="true" [showSpinner]="false"></ng2-pdfjs-viewer>
        </div>
				` :
        '<p>Não foi possível adicionar o componente</p>',
      styleUrls: ['./report-form-dialog.css']
    })
    class DynamicComponent {

      @ViewChild('pdfViewer') pdfViewer;

      data = data;
      report = report;
      values = values;
      isLoading = false;

      constructor(
        public dialogRef: MatDialogRef<ReportFormDialogComponent>,
        public reportService: ReportService,
        public storedFileService: StoredFileService,
        private dialog: MatDialog
      ) { }

      isLoadingReport() {
        return this.isLoading;
      }

      onSelectionChage(queryName: string) {
        this.reportService.load(report.SqlCode, values, queryName).subscribe(data => {
          let result = JSON.parse(data.json());
          this.data[queryName] = result[queryName];
        });
      }

      submit() {
        this.isLoading = true;
        this.reportService.view(report.Identifier, values).subscribe(data => {
          this.isLoading = false;
          const file = new Blob([data], { type: data.type });

          this.storedFileService.view(file, false, this.pdfViewer, report.Title);
          this.dialogRef.close();
        }, () => {
          this.dialogRef.close();
        });
      }
    }
    return DynamicComponent;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-form-dialog/report-form-dialog.ts